module.exports = __webpack_public_path__ + "static/media/plus.f196156d.svg";